import Info from './Info';

export { Info };
